// @flow
/**
 * @module Actions/Search
 * @desc Smart search actions
 */
import { createActions } from 'redux-actions';

import { ActionTypes } from 'constants/index';

export const { getSearchSuggestions, clearSearchSuggestions } = createActions({
  [ActionTypes.GET_SEARCH_SUGGESTIONS]: params => params,
  [ActionTypes.CLEAR_SEARCH_SUGGESTIONS]: () => ({}),
});
